import { Schema } from 'effect';

import { BigDecimal } from '../primitive/bigDecimal';
import { IntegerNatural, Number } from '../primitive/number';
import { StringOptionalProperty, StringRequired } from '../primitive/string';

/**
 * GA4 Item schema for ecommerce tracking
 * Based on: https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtm
 */
export const GtmItemSchema = Schema.Struct({
  // Required fields
  id: StringRequired,
  name: StringRequired,

  // Optional fields
  affiliation: StringOptionalProperty,
  coupon: StringOptionalProperty,
  discount: Schema.optional(BigDecimal),
  index: Schema.optional(IntegerNatural),
  brand: StringOptionalProperty,
  categories: Schema.optional(Schema.Array(Schema.String)),
  item_list_id: StringOptionalProperty,
  item_list_name: StringOptionalProperty,
  item_variant: StringOptionalProperty,
  location_id: StringOptionalProperty,
  availability: Schema.optional(Schema.Literals(['InStock', 'OutOfStock'])),
  price: Number,
  price_with_tax: Number,
  quantity: Schema.optional(IntegerNatural),
}).annotate({ identifier: 'GtmItemSchema' });

export type GtmItem = Schema.Schema.Type<typeof GtmItemSchema>;

/**
 * Array of items for GA4 ecommerce events (max 200 items)
 */
export const GtmItemsArraySchema = Schema.Array(GtmItemSchema)
  .check(Schema.isMaxLength(200))
  .annotate({ identifier: 'GtmItemsArraySchema' });

export type GtmItemsArray = Schema.Schema.Type<typeof GtmItemsArraySchema>;
